import React, { MouseEvent, useEffect, useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import AccountTag from '../../model/AccountTag';
import TagView from './TagView';
import TagForm from './TagForm';

type Props = {
    onChangeTags: Function
    initialTags: number[]
}

const TagsSelect = ({onChangeTags, initialTags}:Props) => {
  const intl = useIntl();
  
  const accountTags = useSelector((state: RootState) => state.app.accountTags);
  const [tags, setTags] = useState<number[]>(initialTags);

  const [showTagsContainer, setShowTagsContainer] = useState<boolean>(false);
  const inputEl = useRef<HTMLInputElement>(null);
  const tagsInputComponentRef = useRef<HTMLInputElement>(null);

  const defineAccountTags = (iTags: number[]) : AccountTag[] => {
    let at: AccountTag[] = [];
    for(var i=0; i< accountTags.length; i++) {
        let accountTag = accountTags[i];

        if (iTags.indexOf(accountTag.tagId!) > -1) {
            at.push(accountTag)
        }
    }
    return at;
  }
  
  const filterSelectedTags = () : AccountTag[] => {
    let at: AccountTag[] = [];
    for(var i=0; i< accountTags.length; i++) {
        let accountTag = accountTags[i];

        if (tags.indexOf(accountTag.tagId!) > -1) continue;

        at.push(accountTag)
        
    }
    return at;
  }
  
  const removeTag = (event:MouseEvent<HTMLElement>, accountTag: AccountTag) => {
    let index = tags.indexOf(accountTag.tagId!);
    if (index > -1) {
      let t = [...tags];
      t.splice(index, 1);
      setTags(t);
    }
  }

  const onSelectAccountTag = (accounTag: AccountTag) => {
    setTags([...tags, accounTag.tagId!]);
    return false;
  }

  const onPressShowTagButton = () => {
    if(!showTagsContainer) {
      setShowTagsContainer(true);  
    }
  }

  useEffect(() => {
    if (onChangeTags !== undefined) {
      onChangeTags(tags);
    }    
  }, [tags])

  useEffect(() => {
    setTags(initialTags)
  },[initialTags])

  useEffect(() => {
    const checkIfClickedOutside = (e:any) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (showTagsContainer && tagsInputComponentRef.current && !tagsInputComponentRef.current.contains(e.target)) {
        setShowTagsContainer(false)
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
        document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [showTagsContainer])

  return (
    <div className="tags-select" ref={tagsInputComponentRef}>
        <div className={'tags-selected-container'}>
          {defineAccountTags(tags).map((accountTag, index) => (
            <TagView key={'selected-account-tag-' + accountTag.tagId} accountTag={accountTag}
              action={(<i className="fa-solid fa-xmark" onClick={(event) => removeTag(event, accountTag)}></i>)}/>

          ))}
        </div>
        <button className="show-tags-button btn btn-primary btn-color" onClick={onPressShowTagButton} type='button'>
          <FormattedMessage id="tags"></FormattedMessage>
        </button>
        <div className={'tags-container ' + (showTagsContainer ? 'show' : '')}>
            {filterSelectedTags().map(accountTag => {
                return <TagView key={'account-tag-' + accountTag.tagId} accountTag={accountTag}
                                onClick={(e:any) => onSelectAccountTag(accountTag)}/>
            })}
            <TagForm/>
        </div>
    </div>
  );
};

export default TagsSelect;